import { FC, useCallback, useEffect, useState } from 'react';
import { auth } from './client/firebase';
import { Loading } from './lib/components/Loading';
import { StudentExperiment, useStudentExperiment } from './api/student-experiment';

const externalRedirectUrl = process.env.REACT_APP_FLUTTER_URL;

const PlatformExperiment: FC = ({ children }) => {
  const [experiment, setExperiment] = useState<StudentExperiment | undefined>();
  const { getExperiment } = useStudentExperiment();
  const [called, setCalled] = useState(false);

  const { currentUser } = auth;

  const handleVerification = useCallback(async (exp: StudentExperiment) => {
    if (currentUser) {
      currentUser.getIdToken().then(token => {
        // eslint-disable-next-line max-len
        if (exp.state === 'flutter') {
          const fullRedirectUrl = `${externalRedirectUrl}/#/external-auth?userToken=${token}`;
          window.location.href = fullRedirectUrl;
        }
      }).catch(err => {
        console.error('Error fetching user token:', err);
      });
    }
  }, [currentUser]);

  const getExperimentCallback = useCallback(async () => {
    setCalled(true);
    const res = await getExperiment();

    setExperiment(res);
    handleVerification(res);
  }, [getExperiment, handleVerification]);

  useEffect(() => {
    if (!called) {
      getExperimentCallback();
    }
  }, [called, getExperimentCallback]);

  if (!experiment) {
    return <Loading />;
  }

  return <>{children}</>;
};

export default PlatformExperiment;
